import { render, staticRenderFns } from "./MailsSectionSearch.vue?vue&type=template&id=08d56485&scoped=true&"
import script from "./MailsSectionSearch.vue?vue&type=script&lang=js&"
export * from "./MailsSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d56485",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
